var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 155,
    viewBox: "0 0 161 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 13044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9686 28.0649C70.4242 34.7195 70.0152 35.4911 70.0152 35.4911L68.6858 59.1196C68.6858 59.1196 61.7324 45.8105 54.6766 47.1607C47.6209 48.5109 49.666 83.6161 49.666 83.6161C49.666 83.6161 50.0751 83.0375 51.8134 83.0375C53.5518 83.0375 58.1534 81.9766 58.1534 81.9766C58.1534 81.9766 65.4136 84.8699 65.7204 85.3521C66.0271 85.8343 82.8995 86.6059 82.8995 86.6059L86.8875 59.0232C86.8875 59.0232 89.6485 76.5758 90.0575 77.058C90.3643 77.5402 85.6605 78.9869 83.6153 79.5655C81.5702 80.1442 93.5342 97.4075 94.0455 97.6968C94.5568 97.9862 128.199 82.3624 128.199 82.3624L121.757 60.1805L112.145 44.7496L76.9686 28.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.875 53.5259C95.9878 63.3631 99.7713 86.9917 99.7713 86.9917L105.6 86.3166L92.9201 48.4144L90.875 53.5259Z",
    fill: "url(#paint0_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.608 84.4841L119.712 62.3987C119.712 62.3987 122.371 61.2414 122.268 61.0485C122.166 60.8556 116.44 49.9575 116.44 49.9575L108.464 41.3741L99.1584 37.2271L97.1133 42.0492C98.4426 42.9172 116.542 65.292 118.996 71.175C121.45 77.058 120.223 85.2557 120.223 85.2557L128.608 84.4841ZM109.793 51.9828L105.498 45.5212C113.168 48.8002 116.338 57.9623 116.338 57.9623L109.793 51.9828Z",
    fill: "url(#paint1_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2319 53.9117C65.3101 61.2413 65.3102 68.2817 65.3102 68.2817L62.2424 83.6161C62.2424 83.6161 63.0605 86.0272 63.265 86.0272C63.4695 86.0272 68.3779 67.3173 68.3779 67.3173L73.3884 48.8002C73.3884 48.8002 71.3433 34.6231 75.5358 31.4404C79.8306 28.2578 77.99 32.6942 77.99 32.6942L80.5464 39.6381C80.5464 39.6381 84.2277 36.8412 84.1254 36.5519C84.0232 36.2626 75.6381 28.1614 75.6381 28.1614L71.9568 31.5369L67.6621 50.8255L65.9237 55.6476L57.0273 48.0286L57.2319 53.9117Z",
    fill: "url(#paint2_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7087 63.4595C57.7418 66.2564 58.2531 68.8603 58.2531 68.8603C58.2531 68.8603 59.0712 79.662 56.1057 80.0477C46.9026 81.3015 47.2094 83.1339 47.7207 82.8446C48.232 82.6517 61.3208 80.7228 61.3208 80.7228L60.4005 64.1346L54.3674 58.2516L51.7087 63.4595Z",
    fill: "url(#paint3_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.311 81.3979C131.471 66.9315 105.907 29.8973 86.58 25.2681C76.0475 22.7605 71.1392 31.0546 68.5828 39.1559C66.5377 45.8104 66.1286 52.1757 65.5151 52.0792C65.2083 51.9828 64.4925 51.4041 63.4699 50.6326C59.891 47.7393 52.6307 41.9527 49.154 48.1251C44.7569 55.937 44.9615 85.9307 43.7344 86.1236C44.4502 86.2201 55.1871 95.6715 67.2535 96.443C76.1498 97.1181 86.7845 97.6968 97.0102 97.7932C106.827 97.8897 115.723 95.6715 122.268 92.4889C125.949 90.7529 128.812 88.7276 130.653 86.7987C132.596 84.8699 133.516 83.0375 133.311 81.3979ZM58.3571 80.4335C56.4142 81.6872 52.5285 82.073 51.9149 81.7837L52.8352 61.3378C52.8352 61.3378 56.4142 60.8556 58.7661 64.3275C61.2203 67.7994 60.3 79.1797 58.3571 80.4335ZM70.3212 48.8002C68.9918 47.6429 69.4009 33.5622 74.9227 30.3795L75.5363 31.8262C75.6385 31.8262 71.6505 49.9575 70.3212 48.8002ZM108.77 44.0745C110.099 44.6531 111.837 45.714 113.576 47.6428C117.359 52.0792 120.325 60.4698 120.325 60.4698C120.325 60.4698 117.871 58.4445 115.11 55.8405C112.86 53.7188 110.304 51.1148 108.872 48.9931L106.009 43.3994C105.907 43.3994 107.031 43.3994 108.77 44.0745ZM103.043 84.5805C102.328 85.4485 89.4432 86.0272 87.5003 84.4841C87.5003 84.4841 86.0687 73.3931 86.2732 69.439C86.4777 65.4848 93.329 55.3583 93.329 55.3583C93.329 55.3583 103.759 83.7126 103.043 84.5805ZM124.108 83.6161C123.188 83.2303 111.326 85.6414 107.849 85.0628C107.44 84.9663 107.236 84.8699 107.031 84.7734C105.395 83.4232 98.544 55.1654 97.8283 51.8863C97.2147 48.5108 100.896 40.7954 100.896 40.7954C100.896 40.7954 111.633 55.069 117.871 63.7488C120.12 66.835 121.756 69.2461 122.165 69.9212C123.495 72.5252 125.131 84.0983 124.108 83.6161Z",
    fill: "url(#paint4_radial_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2516 86.7988C90.9779 92.1031 100.897 95.9608 105.907 96.4431C95.784 96.3466 72.0604 96.7324 63.1641 96.1537C65.516 93.6462 76.9687 76.8651 70.8333 61.6271C69.2995 57.7694 67.3566 54.4903 65.1069 51.597C66.1295 52.465 66.2318 52.6579 66.5385 52.6579C67.0498 52.7544 67.4589 46.3891 69.6062 39.7346C68.2769 55.6477 75.1281 77.3473 85.2516 86.7988Z",
    fill: "url(#paint5_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8555 51.597C76.9683 64.6169 98.2378 47.8358 94.352 37.1306C90.5685 26.6183 85.8647 26.2325 82.8992 26.2325C70.2194 26.0396 68.2765 42.3385 71.8555 51.597Z",
    fill: "url(#paint6_linear_911_1673)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.575 25.1716C103.348 25.0752 101.405 23.0499 99.5648 20.3495C96.9061 16.4918 94.452 11.5732 94.6565 10.1265C95.0655 7.71544 103.86 0 106.621 0C106.723 0 106.825 -1.47304e-06 107.03 0.0964416C107.439 0.385771 107.848 1.15732 108.154 2.31463C108.563 3.66483 108.87 5.40081 108.972 7.42611C109.688 14.4665 108.87 23.8214 104.575 25.1716Z",
    fill: "url(#paint7_radial_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.768 34.9124C107.644 34.7195 106.826 32.9835 106.519 31.344C106.314 30.0902 106.417 28.9329 107.132 28.5471C107.337 28.3542 107.644 28.1613 107.95 27.9685C109.484 26.9076 111.734 25.4609 113.37 28.4507C113.984 29.608 110.711 35.2981 108.768 34.9124Z",
    fill: "url(#paint8_radial_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.871 29.2223C108.769 29.3187 108.155 30.0902 107.644 29.7045C107.542 29.4151 107.644 29.1258 107.746 28.9329C107.848 28.9329 107.848 28.8365 107.951 28.8365C108.666 28.4507 108.973 29.1258 108.871 29.2223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8043 10.9945C99.2584 12.5376 100.179 10.3194 100.179 9.8372C100.179 9.25854 96.4975 9.64431 96.5997 10.0301C96.702 10.4159 96.8043 10.9945 96.8043 10.9945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.108 21.4103C114.086 21.121 115.517 18.7099 116.642 19.385C117.767 20.1566 116.744 21.989 115.108 21.4103Z",
    fill: "url(#paint9_radial_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.474 24.0143C103.247 23.9179 101.304 21.8926 99.4634 19.1922C99.6679 19.1922 98.2363 13.0198 101.815 10.9945C105.394 8.9692 109.28 8.67987 108.155 2.41107C108.564 3.76127 108.871 5.49725 108.973 7.52255C109.485 14.2736 108.564 22.6641 104.474 24.0143Z",
    fill: "url(#paint10_linear_911_1673)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5332 29.608C84.5332 30.476 83.3061 35.9733 79.0113 35.3946C77.7843 33.8515 76.9662 32.1156 77.5797 31.0547C77.7842 30.6689 77.9888 30.1867 78.2955 29.7045C80.9542 26.1361 84.5332 28.6436 84.5332 29.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8175 43.0136C92.8175 43.3029 92.4084 45.0389 91.0791 44.846C90.6701 44.3638 90.4656 43.7851 90.6701 43.4958C90.7723 43.3994 90.7723 43.2065 90.8746 43.11C91.6926 41.9527 92.8175 42.7243 92.8175 43.0136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5422 57.0943C53.1438 63.556 62.7559 54.1045 60.3017 50.4397C57.8476 46.7749 53.4505 45.9069 51.6099 46.6784C48.9512 47.8357 47.1106 54.9725 48.5422 57.0943Z",
    fill: "url(#paint11_linear_911_1673)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1435 48.1251C53.2458 48.4144 53.1435 50.3432 51.7119 51.4041C51.2007 51.3077 50.8939 50.9219 50.9962 50.4397C50.9962 50.2468 51.0984 50.0539 51.0984 49.861C51.8142 48.0286 53.0413 47.8357 53.1435 48.1251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5869 53.8152C50.5869 53.9117 50.7914 54.5867 50.2801 54.7796C50.0756 54.6832 49.8711 54.5867 49.8711 54.3939C49.8711 54.2974 49.8711 54.2974 49.8711 54.201C49.9734 53.6223 50.5869 53.7188 50.5869 53.8152Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0058 85.2556C47.0058 85.2556 56.9247 92.8746 61.8331 92.8746C66.7414 92.8746 73.3881 74.8398 71.9565 68.3781C70.4227 61.82 68.0707 59.6018 68.0707 59.6018C68.0707 59.6018 72.3655 68.9568 66.5369 73.2003C60.7082 77.4438 51.1984 71.9465 48.5397 74.2611C45.881 76.4793 47.0058 85.2556 47.0058 85.2556Z",
    fill: "url(#paint12_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.185 82.8446C132.083 84.2912 131.674 85.6414 130.855 86.7987C129.117 89.4027 125.947 91.2351 122.47 92.4889C115.006 95.2857 106.007 95.6715 106.007 95.6715C106.007 95.6715 105.598 90.0778 107.95 85.1592C111.427 85.7378 125.538 83.6161 126.356 84.0019C127.276 84.4841 124.516 71.9465 123.186 69.439C122.879 68.7639 120.016 66.3528 117.767 63.1702C117.051 60.5662 116.233 58.6373 115.006 55.9369C113.063 51.6934 110.813 47.5464 108.768 44.0745C105.803 39.1559 103.348 35.6839 103.246 35.5875C103.451 35.8768 133.105 65.967 132.185 82.8446Z",
    fill: "url(#paint13_linear_911_1673)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.918 112.549L134.842 120.843H134.331V120.747L134.229 120.843L133.922 119.107L133.82 118.721L123.594 121.325H122.981L114.8 116.985L99.7684 122.29L98.5413 119.686L91.9969 119.879L91.5879 119.782L91.2811 117.371L80.9531 117.468H80.8509L79.2148 111.778L71.9545 112.935L68.5801 113.513V113.803L67.9665 119.011H68.0688L40.6639 117.178L40.1527 110.234C40.1527 110.234 39.0278 117.661 38.312 122.193L26.2457 123.254L13.2591 119.493C13.1569 119.107 13.0546 118.721 12.9523 118.336C12.9523 118.239 12.9523 118.239 12.9523 118.143C12.8501 117.853 12.7478 117.468 12.7478 117.178C12.7478 116.985 12.6456 116.889 12.6456 116.696C12.5433 116.407 12.5433 116.214 12.4411 115.925C12.4411 115.828 12.4411 115.732 12.3388 115.635C12.1343 114.767 11.9298 113.899 11.7253 113.031C11.623 112.549 11.5207 112.163 11.4185 111.681C11.4185 111.681 11.4185 111.681 11.4185 111.585C11.4185 111.488 11.4185 111.392 11.3162 111.392C11.3162 111.295 11.3162 111.199 11.214 111.199C11.214 111.102 11.214 111.006 11.1117 110.91C11.1117 110.813 11.1117 110.717 11.0095 110.62C11.0095 110.524 11.0095 110.427 10.9072 110.427C10.9072 110.331 10.8049 110.234 10.8049 110.138C10.8049 110.042 10.7027 109.945 10.7027 109.752C10.7027 109.656 10.7027 109.656 10.7027 109.559C10.7027 109.463 10.7027 109.366 10.6004 109.27C10.6004 109.174 10.6004 109.174 10.6004 109.077C10.4982 108.788 10.4982 108.498 10.3959 108.209C10.3959 108.113 10.3959 108.113 10.3959 108.016C10.2937 107.63 10.1914 107.341 10.1914 107.052C10.1914 107.052 14.9975 103.098 20.6216 98.4684C20.7239 98.3719 20.8261 98.2755 20.9284 98.2755L34.8353 102.808L32.3811 88.9205C35.6534 86.2201 38.0053 84.2912 38.312 83.9055L48.64 87.5703L70.7275 92.5853L75.0222 95.5751L108.562 95.8644L106.415 90.8494L128.4 84.3877L140.671 75.9971L147.829 100.879L150.283 100.59L160.918 112.549Z",
    fill: "url(#paint14_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.345 82.8446L38.4141 83.9055L47.6172 89.017L70.9317 92.6818L75.022 96.4431L115.413 99.1435L108.767 96.0573L75.5333 95.2858L71.9543 91.428L44.345 82.8446Z",
    fill: "url(#paint15_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.369 93.5497L106.621 90.9458L128.606 84.4841L133.31 81.3979L131.879 75.5149L140.877 76.19L142.82 85.1592L122.369 93.5497Z",
    fill: "url(#paint16_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.415 99.1435L114.801 116.889L99.7696 122.193L98.5425 119.589L91.589 119.782L91.2823 117.371L80.9543 117.468H80.8521L79.216 111.778L75.1257 96.7324V96.636L75.0234 96.4431L110.098 98.7577L115.415 99.1435Z",
    fill: "url(#paint17_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.919 112.549L134.843 120.747H134.332L134.23 120.65V120.747L133.821 119.011L133.718 118.625L123.595 121.229H122.981L114.801 116.889L120.936 112.549L121.857 93.5497L142.819 85.8343L140.876 76.19L148.034 101.072L150.488 100.687L160.919 112.549Z",
    fill: "url(#paint18_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9522 117.468H80.8499L79.2138 111.778L71.9536 112.935L68.5791 113.417L68.4768 113.706L67.8633 118.914L70.931 92.6818L75.0213 96.443L75.1235 96.6359V96.7324L80.9522 117.468Z",
    fill: "url(#paint19_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.488 100.687L142.614 107.727L131.264 108.691L147.931 100.976L140.773 76.0936L142.716 85.7379L121.754 93.4533L106.517 90.8494L108.665 95.8644L114.698 98.8541L109.994 98.5648L75.4313 96.8288L70.8297 92.4889L47.6174 89.0169L39.3346 108.981L24.7119 114.092L10.1914 107.148C10.2937 107.438 10.2937 107.727 10.3959 108.113C10.3959 108.113 10.3959 108.209 10.3959 108.306C10.4982 108.595 10.4982 108.884 10.6004 109.174C10.6004 109.27 10.6004 109.27 10.6004 109.366C10.6004 109.463 10.6004 109.559 10.7027 109.656C10.7027 109.752 10.7027 109.752 10.7027 109.849C10.7027 109.945 10.8049 110.042 10.8049 110.234C10.8049 110.331 10.9072 110.427 10.9072 110.524C10.9072 110.62 10.9072 110.717 11.0095 110.717C11.0095 110.813 11.0095 110.91 11.1117 111.006C11.1117 111.102 11.1117 111.199 11.214 111.295C11.214 111.392 11.214 111.488 11.3162 111.488C11.3162 111.585 11.3162 111.681 11.4185 111.681C11.4185 111.681 11.4185 111.681 11.4185 111.778C11.5207 112.163 11.623 112.645 11.7253 113.128C11.9298 113.996 12.1343 114.864 12.3388 115.732C12.3388 115.828 12.3388 115.925 12.4411 116.021C12.5433 116.31 12.5433 116.503 12.6456 116.793C12.6456 116.985 12.7478 117.082 12.7478 117.275C12.8501 117.564 12.9523 117.95 12.9523 118.239C12.9523 118.336 12.9523 118.336 12.9523 118.432C13.0546 118.818 13.1569 119.204 13.2591 119.589L26.1435 123.254L38.2098 122.193C38.9256 117.661 40.0504 110.234 40.0504 110.234L40.5617 117.178L67.9665 119.011H67.8643L68.4778 113.803V113.513L71.8523 112.935L79.1125 111.778L80.7486 117.468H80.8509L91.1788 117.371L91.4856 119.782L94.9624 119.493L98.4391 119.589L99.6662 122.193L114.698 116.889L122.878 121.229H123.492L133.718 118.625L133.82 119.011L131.775 108.788L142.307 108.981L134.229 120.65V120.747H134.74L160.816 112.453L150.488 100.687ZM103.961 117.661L90.1563 117.371L111.732 111.874L114.084 113.031L103.961 117.661Z",
    fill: "#0A1E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.64,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6221 46.6784C29.3139 55.4547 81.9762 72.0429 85.9642 72.8145C90.0545 73.6825 97.7238 78.6011 100.382 81.1086C102.939 83.6161 101.507 83.3268 120.629 85.4485C139.751 87.5703 158.362 80.2406 156.521 77.5402C154.579 74.6469 136.581 70.7892 128.299 68.7639C140.467 73.586 140.774 79.0833 140.774 79.0833C140.058 82.2659 129.628 91.428 97.1102 77.1544C64.5925 62.8809 36.0629 33.7551 36.7787 32.7906C37.4945 31.8262 57.8436 29.8973 77.1701 36.7448C56.9233 27.3898 0.98877 17.3597 0.0684582 19.4815C-1.05637 21.7961 11.9303 37.9021 20.6221 46.6784ZM32.7906 35.1053C39.3351 36.6483 55.3894 50.4397 50.4811 50.4397C45.5728 50.4397 26.7575 39.831 23.5875 36.6484C20.5198 33.5622 26.2462 33.6586 32.7906 35.1053ZM16.0205 29.9938C17.0431 28.5471 18.4747 28.5471 18.4747 29.7045C18.4747 30.7653 20.5198 32.0191 20.5198 32.0191C19.1905 32.8871 14.998 31.4404 16.0205 29.9938Z",
    fill: "url(#paint20_radial_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.605 84.4841L142.819 85.8343L141.183 84.4841L133.309 81.3979L128.605 84.4841Z",
    fill: "url(#paint21_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6172 89.0169L61.2174 88.1489L53.2413 89.7885L70.9318 92.6818L71.9543 91.428L75.2265 94.9964L75.1243 96.6359L70.9318 92.6818L47.6172 89.0169Z",
    fill: "url(#paint22_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3828 88.9205L46.6988 91.0422L47.6191 89.0169L61.2192 88.1489L53.2432 89.7885L40.0521 110.234L38.416 121.518L39.0295 108.884L40.8701 104.641L34.837 102.808L32.3828 88.9205Z",
    fill: "url(#paint23_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7119 114.092L26.1435 123.158L13.2591 119.493L10.1914 107.148L24.7119 114.092Z",
    fill: "#0B2540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8285 113.128L68.5788 113.417L68.4766 113.706L70.1127 99.1434L70.8285 113.128Z",
    fill: "url(#paint24_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.229 120.65V120.747L133.82 119.011L134.229 120.65Z",
    fill: "url(#paint25_linear_911_1673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.936 112.549L122.981 121.229L114.801 116.889L120.936 112.549Z",
    fill: "url(#paint26_linear_911_1673)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M28.5819 126.879L14.1211 133.077L22.0948 141.203L46.151 143.544L59.2603 134.592L47.2322 127.705L28.5819 126.879Z",
    fill: "#12355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.878 144.095L21.5542 150.155L45.3401 154.012L59.2603 145.197V134.592L46.151 143.544L22.0948 141.203L14.1211 133.077L15.878 144.095Z",
    fill: "#0D274C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M27.3672 120.543V132.113C32.2325 134.454 37.5032 135.005 42.9091 134.316V118.891L27.3672 120.543Z",
    fill: "#0D274C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M45.3428 132.939V121.37L42.9102 119.028V134.316L45.3428 132.939Z",
    fill: "#0C426E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M10.207 86.6616L15.8832 85.1466H27.9113L36.1553 89.1408L49.2646 86.6616L70.3476 89.9672L64.5362 90.9313L43.7236 88.4521L31.6954 90.5181L21.9648 86.6616H10.207Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M13.5857 120.543L19.397 119.028L15.8832 86.6616H10.207L13.5857 120.543Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M60.6172 126.604L13.5859 120.543L19.3973 119.028L66.834 125.226L60.6172 126.604Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M64.5366 90.9313L61.1579 112.142L50.8867 113.381L61.1579 116.274L60.6173 126.604L66.8341 125.226V115.31L59.6713 112.968L66.8341 111.04L70.3479 89.9672L64.5366 90.9313Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M10.207 86.6616L13.5857 120.543L61.1576 126.603V116.274L52.5081 113.519L61.1576 112.142L64.5362 90.9312L43.7236 88.4521L31.6954 90.518L21.9648 86.6616H10.207Z",
    fill: "#0D274C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M27.3711 132.25L16.2891 135.143L22.1004 141.203L41.9671 143.131L42.9131 134.316L27.3711 132.25Z",
    fill: "#0D3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M22.0992 141.203L21.5586 150.155L22.3695 150.293L22.0992 141.203Z",
    fill: "#12355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M46.1546 143.544L45.3438 154.012L46.1546 153.461V143.544Z",
    fill: "#12355E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_1673",
    x1: 97.9507,
    y1: 67.133,
    x2: 101.816,
    y2: 126.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_911_1673",
    x1: 113.043,
    y1: 66.1424,
    x2: 116.909,
    y2: 125.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_911_1673",
    x1: 71.5844,
    y1: 51.6427,
    x2: 78.8951,
    y2: 111.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_911_1673",
    x1: 53.6813,
    y1: 70.0382,
    x2: 57.5467,
    y2: 128.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_911_1673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.6132 42.4584) scale(63.542 59.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#FD9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#FD741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FC9387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_911_1673",
    x1: 65.5492,
    y1: 80.3461,
    x2: 86.4854,
    y2: 67.3207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_911_1673",
    x1: 68.3325,
    y1: 14.3543,
    x2: 92.1641,
    y2: 68.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_911_1673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.184 7.28357) scale(21.1865 19.9819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#FD9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#FD741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FC9387"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_911_1673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.066 29.4843) scale(7.01932 6.62024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#FD9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#FD741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FC9387"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_911_1673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.677 15.476) scale(22.5646 21.2817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#FD9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#FD741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FC9387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_911_1673",
    x1: 121.568,
    y1: 29.2326,
    x2: 102.747,
    y2: 7.59157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_911_1673",
    x1: 52.1716,
    y1: 49.7569,
    x2: 56.8622,
    y2: 59.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_911_1673",
    x1: 79.195,
    y1: 100.681,
    x2: 61.8058,
    y2: 75.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_911_1673",
    x1: 149.056,
    y1: 76.4118,
    x2: 110.061,
    y2: 65.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_911_1673",
    x1: 92.4265,
    y1: 135.374,
    x2: 89.7875,
    y2: 124.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_911_1673",
    x1: 74.3747,
    y1: 105.564,
    x2: 78.1981,
    y2: 81.8046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_911_1673",
    x1: 124.043,
    y1: 82.3724,
    x2: 125.474,
    y2: 96.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_911_1673",
    x1: 75.0716,
    y1: 109.345,
    x2: 115.419,
    y2: 109.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_911_1673",
    x1: 114.824,
    y1: 98.7028,
    x2: 160.885,
    y2: 98.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_911_1673",
    x1: 75.1213,
    y1: 120.769,
    x2: 73.9332,
    y2: 115.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7237B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A1C98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_911_1673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.4264 49.447) scale(132.897 125.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000980945,
    stopColor: "#06FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255499,
    stopColor: "#10F7FD",
    stopOpacity: 0.9852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#3AD5FE",
    stopOpacity: 0.9195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    stopColor: "#5EB8FE",
    stopOpacity: 0.8501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#7CA1FE",
    stopOpacity: 0.7776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#928FFF",
    stopOpacity: 0.7009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#A382FF",
    stopOpacity: 0.6182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AC7AFF",
    stopOpacity: 0.5251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF78FF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_911_1673",
    x1: 135.714,
    y1: 85.7994,
    x2: 135.714,
    y2: 81.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_911_1673",
    x1: 61.4245,
    y1: 96.6161,
    x2: 61.4245,
    y2: 88.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_911_1673",
    x1: 54.0389,
    y1: 120.018,
    x2: 52.556,
    y2: 113.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_911_1673",
    x1: 71.399,
    y1: 113.999,
    x2: 70.782,
    y2: 111.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_911_1673",
    x1: 134.283,
    y1: 120.86,
    x2: 134.204,
    y2: 120.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7237B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A1C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_911_1673",
    x1: 120.047,
    y1: 122.615,
    x2: 119.644,
    y2: 120.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibImg1);
export default __webpack_public_path__ + "static/media/lib_img1.341cbf0a4d0f8e86785d14eda903ad97.svg";
export { ForwardRef as ReactComponent };